<template>
  <v-card flat class="mb-2 py-2">
    <v-layout row align-center>
      <img
        class="icon ml-2 mr-4"
        src="@/assets/image/application/invoice.svg"
        alt="Ícone de Boleto"
        style="width: 32px"
      />

      <v-dialog v-model="addPaymentSlip" persistent width="500">
        <template v-slot:activator="{ on }">
          <v-btn
            outline
            small
            color="primary"
            v-on="on"
          >
            Adicionar Boleto
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline green white--text" primary-title>
            Adicionar boleto de complemento
          </v-card-title>

          <v-card-text>
            <v-form>
              <v-text-field
                v-model="value"
                v-money="money"
                prefix="R$"
                label="Valor"
                required
              />
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click="addPaymentSlip = false">Cancelar</v-btn>
            <v-btn
              flat
              color="primary"
              :disabled="minValue"
              @click="createAdditionalPaymentSlip()"
            >
              Adicionar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money';
import PaymentSlipsService from '@/services/applications/PaymentSlipsService';

export default {
  directives: { money: VMoney },
  name: 'AdditionalPaymentSlip',
  props: ['applicationId'],
  data() {
    return {
      addPaymentSlip: false,
      value: '',
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
      }
    }
  },
  methods: {
    createAdditionalPaymentSlip() {
      PaymentSlipsService
        .createAdditionalPaymentSlip({
          applicationId: this.applicationId,
          value: this.value.replace(/[.]+/g, '').replace(',', '.')
        })
        .then(() => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'green',
            message: 'Boleto de complemento adicionado',
            messageIcon: 'mdi-alert-circle',
          });
          this.$router.go();
        })
        .catch((response) => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'error',
            message: response.data.join(', '),
            messageIcon: 'mdi-alert-circle',
          });
        })
    }
  },
  computed: {
    minValue() {
      const value = this.value.replace(/[.,]+/g, '')
      return parseFloat(value) <= 0;
    }
  }
}
</script>